import { STORAGE_KEYS } from '@/shared/lib/storageKeys';
import type { RootState } from './store';

const STORAGE_KEY = STORAGE_KEYS.appState;

/** Slices (or parts of slices) that survive a reload. Keep this list small and intentional. */
export type PersistedState = Pick<RootState, 'preferences'> & {
  nav: Pick<RootState['nav'], 'mode'>;
};

export const loadPersistedState = (): Partial<PersistedState> | undefined => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Partial<PersistedState>) : undefined;
  } catch {
    return undefined; // private mode, blocked storage or corrupt JSON
  }
};

export const savePersistedState = (state: RootState) => {
  const persisted: PersistedState = {
    preferences: state.preferences,
    nav: { mode: state.nav.mode },
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(persisted));
  } catch {
    // Storage unavailable – the app keeps working with in-memory state.
  }
};
